import io from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = 'https://notifications.facesconsent.com:22096';

export const socket = io(URL);